import { z } from "zod";

// Schema para documento
export const documentSchema = z.object({
  id: z.string().optional(),
  name: z
    .string()
    .min(1, "El nombre del documento es requerido")
    .max(255, "El nombre del documento es demasiado largo"),
  type: z.enum(["PDF", "Excel", "PowerPoint", "Word", "Image", "Other"]),
  size: z.number().positive("El tamaño debe ser positivo"),
  sizeFormatted: z.string().optional(),
  uploadedBy: z.string().min(1, "El usuario que subió es requerido"),
  date: z.string().optional(),
  url: z.string().url("URL inválida").optional(),
  description: z.string().max(1000, "La descripción es demasiado larga").optional(),
  tags: z.array(z.string()).optional(),
  isPublic: z.boolean().default(false),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

// Schema para subir documento
export const uploadDocumentSchema = z.object({
  file: z.instanceof(File, { message: "Archivo requerido" }),
  name: z
    .string()
    .min(1, "El nombre del documento es requerido")
    .max(255, "El nombre del documento es demasiado largo"),
  description: z.string().max(1000, "La descripción es demasiado larga").optional(),
  tags: z.array(z.string()).optional(),
  isPublic: z.boolean().default(false),
});

// Schema para filtros de documentos
export const documentFiltersSchema = z.object({
  search: z.string().optional(),
  type: z.enum(["PDF", "Excel", "PowerPoint", "Word", "Image", "Other"]).optional(),
  uploadedBy: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  sortBy: z.enum(["name", "type", "size", "date", "uploadedBy"]).optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  isPublic: z.boolean().optional(),
});

// Schema para actualizar documento
export const updateDocumentSchema = documentSchema.partial().omit({
  id: true,
  size: true,
  sizeFormatted: true,
  uploadedBy: true,
  date: true,
  url: true,
  createdAt: true,
  updatedAt: true,
});

// Tipos inferidos de los schemas
export type Document = z.infer<typeof documentSchema>;
export type UploadDocumentData = z.infer<typeof uploadDocumentSchema>;
export type DocumentFilters = z.infer<typeof documentFiltersSchema>;
export type UpdateDocumentData = z.infer<typeof updateDocumentSchema>;
